exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td{padding:5px 10px}.company-wrapper{display:flex;justify-content:start;align-items:center;flex-wrap:wrap;gap:20px}.company-chidl1{width:50%}.company-chidl2{width:100%}.form-control[readonly]{background-color:unset}.dropdown-toggle{height:38px!important}.cron-query-content{display:grid;overflow-y:scroll;height:580px}.sector-query-content{overflow-y:scroll;align-content:start;height:560px}.n-lbl{background:#fdffed;padding:0 5px;border-radius:7px}.text-small{font-size:small}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28231968","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/reports/stock-history.vue
// module id = 670
// module chunks = 27